<div class="system-mapping-wrapper">
  <div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         ap-tooltip [appendAfterTarget]="true" tooltipContent="Refresh Data"
         direction="right"
         role="button"
         tabindex="0"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="refresh(); $event.preventDefault()"></i>
    </div>

    <div class="gt-filter-item">
      <label class="gt-filter-label">Tax Year:</label>
      <select class="gt-filter-select"
              [(ngModel)]="selectedTaxYear"
              (ngModelChange)="onTaxYearChange()">
        @for (ty of taxYears; track $index) {
<option [ngValue]="ty">{{ ty.label }}</option>
}
      </select>
    </div>

    <div class="gt-filter-item">
      <button type="button" class="btn btn-success btn-xs" (click)="refresh()">Filter</button>
    </div>

    <div class="gt-filter-item">
      <button type="button" class="btn btn-success btn-xs" (click)="addNewSystemAccount()">
        Add New System Account
      </button>
    </div>
  </div>

  <div class="grid-host">
    <div adminGrid
         [gridConfig]="gridConfig"
         (gridCallback)="onGridCallback($event)"
         (loadingStateChange)="onLoadingChange($event)"
         class="gizmo-grid"
         tabindex="2"></div>
  </div>
</div>
